import React from 'react';
import PropTypes from 'prop-types';

import {greyishBlue100, greyishBlue500, greyishBlue900} from "assets/jss/main";

CurrentOrganizationInfos.propTypes = {
    organization: PropTypes.object,
    member: PropTypes.object
};

function CurrentOrganizationInfos({organization, member}) {
    if (!organization || !member) {
        return null;
    }

    return (
        <div style={{
            padding: '12px',
            display: 'flex',
            flexDirection: 'column',
        }}>
            <span style={{
                fontSize: '14px',
                fontWeight: 600,
                color: greyishBlue900
            }}>
                {organization.name}
            </span>
            <span style={{
                fontSize: '12px',
                fontWeight: 400,
                color: greyishBlue500
            }}>
                {member.email}
            </span>
        </div>
    );
}

export default CurrentOrganizationInfos;
